import React from 'react'
import CardUI from '../../widgets/layout/CardUI'
import FormSF from '../../widgets/form/FormSF'
import InputNameSF from '../../widgets/form/InputNameSF'

const NameUpdateUI = ({context, firstName, lastName,
    messageList, successMsg, errorList, firstNameError, lastNameError,
    submitted,
    // event handlers
    onSubmit, onCancel, setErrorList, onFirstNameChange, onLastNameChange, setFirstNameError, setLastNameError
  }) =>
  <CardUI context={context}>
    <FormSF context={context}
      messageList={messageList} buttonMessageKey='c_update' cancelMessageKey='c_cancel'
      successMsg={successMsg} errorList={errorList}
      busy={submitted} onSubmit={onSubmit} onCancel={onCancel} setErrorList={setErrorList}
    >
      <InputNameSF type='name' required={true} name='name' firstName={firstName} lastName={lastName}
        messageList={messageList} labelKey='c_name'
        firstNameError={firstNameError} lastNameError={lastNameError}
        onFirstNameChange={onFirstNameChange} onLastNameChange={onLastNameChange}
        setFirstNameError={setFirstNameError} setLastNameError={setLastNameError}
        autoFocus={true}
      />
    </FormSF>
  </CardUI>

export default NameUpdateUI
